export const USER_PROFILE_FETCH = 'USER_PROFILE_FETCH';
export const USER_PROFILE_FETCH_ERROR = 'USER_PROFILE_FETCH_ERROR';
export const USER_PROFILE_FETCHING = 'USER_PROFILE_FETCHING';
export const USER_PROFILE_SUBMITTING = 'USER_PROFILE_SUBMITTING';
export const USER_PROFILE_SUBMIT = 'USER_PROFILE_SUBMIT';
export const USER_PROFILE_SUBMIT_ERROR = 'USER_PROFILE_SUBMIT_ERROR';



// WEBPACK FOOTER //
// ./src/pages/userprofile/state/userprofile/types.js